import { Injectable } from '@angular/core';

import { RidangoReduxAction } from '@ridango/core';


@Injectable()
export class SubscriptionActions {
    static LOAD_SUBSCRIPTIONS = '[Subscription]: Load subscriptions'; // this is for effects later on
    static LOAD_SUBSCRIPTIONS_SUCCESS = '[Subscription]: Load subscriptions success';
    static LOAD_SUBSCRIPTIONS_ERROR = '[Subscription]: Load subscriptions error';

    static DELETE_SUBSCRIPTION = '[Subscription] Delete Subscription'; // this is for effects later on
    static DELETE_SUBSCRIPTION_SUCCESS = '[Subscription] Delete Subscription Success';
    static DELETE_SUBSCRIPTION_ERROR = '[Subscription] Delete Subscription Error';
    setSubscriptions ( payload: any ): RidangoReduxAction {
        return {
            type: SubscriptionActions.LOAD_SUBSCRIPTIONS_SUCCESS,
            payload: payload
        };
    }

    deleteSubscripton (): RidangoReduxAction {
        return {
            type: SubscriptionActions.DELETE_SUBSCRIPTION
        };
    }

    deleteSubscriptionSuccess ( subscription ): RidangoReduxAction {
        return {
            type: SubscriptionActions.DELETE_SUBSCRIPTION_SUCCESS,
            payload: subscription
        };
    }

    deleteSubscriptionError ( payload: any ): RidangoReduxAction {
        return {
            type: SubscriptionActions.DELETE_SUBSCRIPTION_SUCCESS,
            payload: payload
        };
    }

}
